import { render, staticRenderFns } from "./cart-icon.vue?vue&type=template&id=8852d834&scoped=true&lang=pug&"
import script from "./cart-icon.vue?vue&type=script&lang=coffee&"
export * from "./cart-icon.vue?vue&type=script&lang=coffee&"
import style0 from "./cart-icon.vue?vue&type=style&index=0&id=8852d834&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8852d834",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default})
